import { render, staticRenderFns } from "./BlackCard.vue?vue&type=template&id=54f410f1&scoped=true"
import script from "./BlackCard.vue?vue&type=script&lang=js"
export * from "./BlackCard.vue?vue&type=script&lang=js"
import style0 from "./BlackCard.vue?vue&type=style&index=0&id=54f410f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f410f1",
  null
  
)

export default component.exports